import SecondaryAction from './SecondaryAction';

export default SecondaryAction;
